import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MyTreeElements } from 'mbs-ui-shared@models/backup/storages-type';
import { FormsUtil, ModalComponent } from 'mbs-ui-kit';

type CredentialsForm = {
  login: FormControl<string>;
  password: FormControl<string>;
};

@Component({
  selector: 'mbs-credentials-modal',
  templateUrl: './credentials-modal.component.html'
})
export class CredentialsModalComponent implements OnInit {
  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public root: MyTreeElements;

  public form: FormGroup<CredentialsForm> = new FormGroup<CredentialsForm>({
    login: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required)
  });

  ngOnInit(): void {
    if (this.baseModal.data) {
      this.root = this.baseModal.data.root;
    }
  }

  saveCredentials(): void {
    FormsUtil.triggerValidation(this.form);

    if (this.form.invalid) return;

    const value = this.form.value;

    this.baseModal.save(value);
  }

  cancelClickHandler(): void {
    this.baseModal.close();
  }
}
